import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "./LoginSlice";
import { logoutUser } from "./AccountLogoutThunk";

/**
 * fetch all Waitlist entries
 */
export const fetchWaitlistItems = createAsyncThunk(
  "waitlist/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/waitlist`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateWaitlistItems = createAsyncThunk(
  "waitlist/updateItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/waitlist?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);